<template>
  <b-form-group
    label="Başlangıç Tarihi"
    label-for="edate"
  >
    <b-form-datepicker
      id="edate"
      v-model="filterData.edate"
      v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  name: 'EndDate',
  components: {
    BFormGroup,
    BFormDatepicker,
  },
  computed: {
    filterData() {
      return this.$store.getters['interviews/filterData']
    },
  },
}
</script>
